import { registerAdditionalQuickActions } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import { registerAdditionalQuickActionsInternal } from '../selectors/getAdditionalQuickActions';

export default orchestrator(registerAdditionalQuickActions, actionMessage => {
    registerAdditionalQuickActionsInternal(actionMessage.scenarioId, actionMessage.callback);
});
